module.exports = __webpack_public_path__ + "img/minus_btn.9267c114.png";